<template>
    <div class="col-11 race-comments mt-2"  v-html="this.$options.filters.boldname(raceComments)" ></div>
</template>

<script>
    export default {
        name: 'RaceCardRaceComments',
        data: function () {
            return {
            };
        },
        filters:{
            boldname:function(value){
                value=value.toString()
                value=value.replace(/(\b[A-Z]{2,}\b)/g,'<b>$1</b>');
                return  value
            }
        },
        props: {
            raceComments: String
        }
    }
</script>

<style scoped>
    .race-comments {
        font-size: 0.95rem;
    }

    @media (min-width: 1200px) {
        .race-comments {
            font-size: 0.9rem;
        }

    }
</style>
